// React
import React from 'react';

// Components
import Wrapper from '../../listing/Wrapper/Wrapper';

// Contexts
import { ListingContext } from '../../../contexts/listing';

// Hooks
import useListing from '../../../hooks/useListing';

// Data types
import {
  accessoryCore,
  accessoryListing
} from '../../../data-types/accessory';

// This component
export default function Accessory() {
  // Data types
  const { endpoint } = accessoryCore();
  const {
    initialSort,
    initialFilters,
    getColumns,
    getRows,
    getFilters
  } = accessoryListing();

  // Listing
  const {
    activeFilters,
    saveActiveFilters,
    page,
    pageSize,
    setPage,
    setPageSize,
    sortModel,
    setSortModel,
    resetSortModel,
    refreshDataGrid,
    setRefreshDataGrid
  } = useListing(initialSort, initialFilters, endpoint);

  // JSX
  return (
    <ListingContext.Provider
      value={{
        typeOfData: 'data-type',
        // Static
        initialFilters,
        endpoint,
        getColumns,
        getRows,
        getFilters,
        // Dynamic
        activeFilters,
        saveActiveFilters,
        page,
        pageSize,
        setPage,
        setPageSize,
        sortModel,
        setSortModel,
        resetSortModel,
        refreshDataGrid,
        setRefreshDataGrid
      }}>
      <Wrapper
        title="Accessories"
        buttonNewLabel="New Accessory"
        buttonNewUrl="/accessory/new"
        exportAction={true}
        buttonExportLabel="Export Data"
      />
    </ListingContext.Provider>
  );
}
